import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { Table } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { Dropdown } from "primeng/dropdown";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-accounts-report',
  templateUrl: './accounts-report.component.html',
  styleUrls: ['./accounts-report.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class AccountsReportComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public lastTableLazyLoadEvent: LazyLoadEvent;
  loading: boolean;
  paginationOption;
  minYear = environment.minYear;
  submitted: boolean = false;
  rsubmitted: boolean = false;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  downloadFlg: boolean = false;
  startDate: any;
  endDate: any;
  searchby: any;
  searchBy: { label: string; value: string; }[];
  calvalue: null;
  errorMessage: any;
  accountsReportData: any = [];
  accounts: any = [];
  totalRecords: any = 0;
  accountsData: any[] = [];

  constructor(private userWalletService: UserWalletService) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
    ];
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = "";
    this.downloadFlg = false;
    this.dt.sortField = null;
    this.dt._first = 0;
    this.dt._rows = 10;
    this.dt.filter('', '_id', 'contains');
    this.dt.filter('', 'fullName', 'contains');
    this.dt.filter('', 'totalAmount', 'contains');
    this.dt.filter('', 'description', 'contains');
  }

  exportExcel() {
    this.downloadFlg = true;
    this.accountsReportList(this.lastTableLazyLoadEvent);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  accountsReportList(event: LazyLoadEvent) {
      event = event || {} as LazyLoadEvent;
      this.lastTableLazyLoadEvent = event;
      var query = "?filterByDisable=false&filterByStatus=true";
      var params = "";
      var pagenumber = 1;
      var rows = 10;

      if (event && event.first != undefined && event.rows != undefined) {
          pagenumber = (event.first / event.rows) + 1;
          rows = event.rows;
      }

      if (this.startDate != undefined && this.endDate != undefined) {
          params += "&filterByDate=" + (this.searchby && this.searchby.value ? this.searchby.value : "created_at");
          params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
          params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      }

      const getFilterValue = (field) => {
          if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
              return event.filters[field].value;
          }
          return null;
      };
      const idFilter = getFilterValue("_id");
      const nameFilter = getFilterValue("fullName");
      const totalAmountFilter = getFilterValue("totalAmount");
      const descriptionFilter = getFilterValue("description");

      if (idFilter !== null) {
          params += "&filterById=" + encodeURIComponent(idFilter);
      }
      if (nameFilter !== null) {
          params += "&filterByName=" + encodeURIComponent(nameFilter);
      }
      if (totalAmountFilter !== null) {
          params += "&filterByTotalAmount=" + encodeURIComponent(totalAmountFilter);
      }
      if (descriptionFilter !== null) {
          params += "&filterByDescription=" + encodeURIComponent(descriptionFilter);
      }

      if (this.downloadFlg !== true) {
          query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }

      if (params != "") {
          query += params;
      }

      if (event.sortField != undefined && event.sortOrder != undefined) {
          var orderBy = "";
          if (event.sortOrder == 1) {
              orderBy = "ASC";
          } else {
              orderBy = "DESC";
          }
          query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
      }

      this.userWalletService.generateAccountsReport(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
          this.loading = false;
          if (this.downloadFlg === true) {
              this.accountsReport(data.data.items);
          } else {
              this.accountsData = data.data.items;
              this.totalRecords = data.data.totalCount;
          }
      }, (err) => {
          this.downloadFlg = false;
          this.errorMessage = err.error.message;
      });
  }

  accountsReport(data) {
    this.loading = false;
    this.accountsReportData = data;
    const accountsReportData = (this.accountsReportData || []).map(item => ({
      Id: item._id,
      FullName: item.fullName,
      TotalAmount: item.totalAmount,
      Description: item.description,
      GrandTotalAmount: item.grandTotalAmount
    }));
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(accountsReportData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, `AccountsReport`);
    });
    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
